var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ClickEventListener, SelectEventListener } from '@philips-internal/oswald-ui-core/lib/component/types';
export default class CardAppointmentsAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        this.onSelect = new SelectEventListener();
        this.onClick = new ClickEventListener();
        this.onContextMenuClick = new ClickEventListener();
        this.onDoubleClick = new ClickEventListener();
    }
    setCancelSchedules(allowCancelCheckup) {
        this.setState({ allowCancelCheckup });
    }
    setConfirmSchedules(allowConfirmCheckup) {
        this.setState({ allowConfirmCheckup });
    }
    setPatientId(patientId) {
        this.setState({ patientId });
    }
    setFunctionToCancelWaitList(cancelWaitlistItem) {
        this.setState({ cancelWaitlistItem });
    }
    setOnEnterTeleconsultation(onEnterTeleconsultation) {
        this.setState({ onEnterTeleconsultation });
    }
    setOnAppointmentRescheduleMore(onAppointmentRescheduleMore) {
        this.setState({ onAppointmentRescheduleMore: onAppointmentRescheduleMore });
    }
    setOnAppointmentReschedule(onAppointmentReschedule) {
        this.setState({ onAppointmentReschedule: onAppointmentReschedule });
    }
    setOnAppointmentCancel(onAppointmentCancel) {
        this.setState({ onAppointmentCancel: onAppointmentCancel });
    }
    setOnAppointmentConfirm(onAppointmentConfirm) {
        this.setState({ onAppointmentConfirm: onAppointmentConfirm });
    }
    setRescheduleConsultation(rescheduleCheckup, rescheduleConsultation, rescheduleExam, rescheduleService) {
        this.setState({ rescheduleCheckup, rescheduleConsultation, rescheduleExam, rescheduleService });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], CardAppointmentsAPI.prototype, "onSelect", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], CardAppointmentsAPI.prototype, "onClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], CardAppointmentsAPI.prototype, "onContextMenuClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], CardAppointmentsAPI.prototype, "onDoubleClick", void 0);
//# sourceMappingURL=card-appointments-api.js.map